import type { MonsterInstance } from '../types/card';

/** 0を未設定値と扱わず、実際に減少させた分だけを復元用に記録する。 */
export function applyTemporaryAttackReduction<T extends MonsterInstance>(monster: T, amount: number): T {
  if (!Number.isFinite(amount) || amount < 0) throw new RangeError('攻撃力減少量が不正です');
  const before = monster.currentAttack ?? monster.attack ?? 0;
  const after = Math.max(0, before - amount);
  return {
    ...monster,
    currentAttack: after,
    tempAttackReduction: (monster.tempAttackReduction ?? 0) + before - after,
  };
}

/** 同時に切れる強化・弱体化をまとめて解除し、他の効果を保持する。 */
export function clearTemporaryAttack<T extends MonsterInstance>(monster: T): T {
  if (monster.attackBuffUntilEndOfTurn === undefined && monster.tempAttackReduction === undefined) return monster;
  const result = {
    ...monster,
    currentAttack: Math.max(0,
      (monster.currentAttack ?? monster.attack ?? 0)
      - (monster.attackBuffUntilEndOfTurn ?? 0)
      + (monster.tempAttackReduction ?? 0)),
  };
  delete result.attackBuffUntilEndOfTurn;
  delete result.tempAttackReduction;
  return result;
}
